module.exports = __webpack_public_path__ + "assets/5df9a0db76270985ce279fec1e20416e.mp3";